/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { BootstrapDialog, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';
import { startAndStop } from '../../../../store/loading/loadingSlice';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  Tab,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete
} from '@mui/material';

import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import axios from 'axios';
import configAxios from '../../../../services/configAxios';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Iconify from '../../../../@core/theme/Iconify';
const allowedPageSizes = [5, 10, 20, 30];

const integrationClientsThird = (props) => {
  const dispatch = useDispatch();
  const [infosHistoryIntegration, setHistoryIntegration] = useState([]);
  const [defaultErrors, setDefaultErros] = useState([]);
  const [resultIntegration, setResultIntegration] = useState([]);
  const infoStateTemp = useSelector(selectLogin);
  const [value, setValue] = useState('1');
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const [infosAdm, setInfosAdm] = useState([]);

  useEffect(() => {
    setHistoryIntegration(props.infosHistoryIntegration);
    setResultIntegration(
      props.infosHistoryIntegration.filter((element) => element.status === 'Integrada')
    );
  }, [props.infosHistoryIntegration]);

  function ChangedDate(date) {
    return date.data.data.integration_at.replaceAll('-', ':');
  }

  function NameUser(infos) {
    if (infos.data.data.nome) {
      return infos.data.data.nome;
    }
    return '-';
  }

  function RenderCodGer(infos) {
    if (infos.data.data.codger) {
      return infos.data.data.codger;
    }
    return '-';
  }

  function HandleTabsChange(event, newValue) {
    setValue(newValue);
  }

  function HandleInputChange(event, params = {}) {
    if (params.codemp) {
      if (event) {
        setInfosAdm({ ...infosAdm, labelEmp: event.label, codemp: event.codemp });
      }
      return;
    }
    if (params.codgrupoemp) {
      if (event) {
        setInfosAdm({ ...infosAdm, labelGrupo: event.label, codgrupo: event.codgrupoemp });
      } else {
        setInfosAdm({ ...infosAdm, labelGrupo: '', codgrupo: '' });
      }
      return;
    }
    if (params.codbanco) {
      if (event) {
        setInfosAdm({ ...infosAdm, labelBank: event.label, codbanco: event.codbanco });
      }
      return;
    }
    setInfosAdm({ ...infosAdm, [event.target.name]: event.target.value });
    return;
  }

  async function IntegrationClient(event) {
    event.preventDefault();
    const urlIntegration = infoState.rotapostback;

    const postObject = {
      infosClient: { ...props.infosClients },
      infosDeps: props.infosDeps
    };
    dispatch(startAndStop(true));
    try {
      await axios.post(`${urlIntegration}/healthMap/integration`, postObject, {
        headers: {
          authorization: `Bearer ${infoState.tokenpostback}`
        }
      });
      dispatch(startAndStop(false));
      const postHistory = {
        id_client: props.infosClients.id,
        user_id: infoState.id,
        status: 'Integrada',
        typeintegration: 'health'
      };
      await configAxios.post('/integration/integrationAddHistory', postHistory);
      NotificationManager.success('Venda integrada com sucesso na HealthMap!', 'Sucesso');
      props.getHistoryIntegration();
      props.setOpenModal(false);
    } catch (error) {
      dispatch(startAndStop(false));
      const postHistory = {
        id_client: props.infosClients.id,
        user_id: infoState.id,
        status: 'Não integrada',
        typeintegration: 'health'
      };
      await configAxios.post('/integration/integrationAddHistory', postHistory);
      props.getHistoryIntegration();
      NotificationManager.error(
        'Tivemos dificuldades para atender a requisição no momento, por favor, tente novamente!',
        'Atenção'
      );
    }
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'sm'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
            }}>
            Integração com a HealthMap
          </BootstrapDialogTitle>
          <Box sx={{ width: '100%' }}>
            <form onSubmit={IntegrationClient}>
              <DialogContent dividers>
                <TabContext value={value}>
                  <TabList onChange={HandleTabsChange} aria-label="SendEmailContract">
                    <Tab label="Histórico" value="1" />
                    {defaultErrors.length && (
                      <Tab label="Campos para adequar" value="3" sx={{ textTransform: 'none' }} />
                    )}
                  </TabList>
                  <TabPanel value="1" variant="fullWidth">
                    <Grid item xs={12} sx={{ mt: -1 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Acompanhe abaixo o histórico de integrações com a HealthMap
                      </Typography>
                    </Grid>
                    <DataGrid
                      dataSource={infosHistoryIntegration}
                      showBorders={true}
                      remoteOperations={true}
                      wordWrapEnabled={true}
                      allowColumnResizing={true}
                      columnAutoWidth={true}
                      noDataText={'Ainda não foram realizadas integrações'}>
                      <Column
                        dataField="nome"
                        caption="Usuário"
                        width={170}
                        cellRender={(data) => <NameUser data={data} />}
                      />
                      <Column dataField="status" caption="Status" />
                      <Column
                        dataField="created_at"
                        caption="Data e hora"
                        cellRender={(data) => <ChangedDate data={data} />}
                      />
                      <SearchPanel visible={true} width={220} placeholder="Procurar..." />
                      <GroupPanel
                        visible={true}
                        emptyPanelText="Arraste as colunas aqui para agrupar"
                      />
                      <Scrolling rowRenderingMode="virtual"></Scrolling>
                      <Paging defaultPageSize={5} />
                      <Pager
                        visible={true}
                        allowedPageSizes={allowedPageSizes}
                        showPageSizeSelector={true}
                        showInfo={true}
                        showNavigationButtons={true}
                      />
                      <ColumnChooser
                        enabled={true}
                        title={'Escolher uma coluna'}
                        emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                      />
                      <ColumnFixing enabled={true} />
                      <HeaderFilter visible={true} allowSearch={true} />
                    </DataGrid>
                  </TabPanel>
                </TabContext>
              </DialogContent>
              <DialogActions>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  disabled={resultIntegration.length ? true : false}
                  startIcon={<Iconify icon="eva:cloud-upload-fill" />}>
                  Integrar
                </Button>
                <Button
                  onClick={() => {
                    props.setOpenModal(false);
                    setDefaultErros([]);
                    setValue('1');
                  }}
                  color="error"
                  variant="contained"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Fechar
                </Button>
              </DialogActions>
            </form>
          </Box>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default integrationClientsThird;
